<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Campaigns</h5>
      <button class="btn btn-primary btn-sm" (click)="newCampaign()">New Campaign</button>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead>
            <tr>
              <th>Name</th>
              <th>Template</th>
              <th>Status</th>
              <th class="text-center">Total</th>
              <th class="text-center">Sent</th>
              <th class="text-center">Delivered</th>
              <th class="text-center">Read</th>
              <th class="text-center">Failed</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading">
              <td colspan="9" class="text-center text-muted">Loading...</td>
            </tr>
            <tr *ngIf="!loading && campaigns.length === 0">
              <td colspan="9" class="text-center text-muted">No campaigns yet.</td>
            </tr>
            <tr *ngFor="let c of campaigns" style="cursor: pointer;" (click)="open(c)">
              <td>{{ c.name }}</td>
              <td>{{ c.templateName }} <small class="text-muted">({{ c.templateLanguage }})</small></td>
              <td><span [class]="statusClass(c.status)">{{ c.status }}</span></td>
              <td class="text-center">{{ c.totalRecipients }}</td>
              <td class="text-center">{{ c.sentCount }}</td>
              <td class="text-center">{{ c.deliveredCount }}</td>
              <td class="text-center">{{ c.readCount }}</td>
              <td class="text-center">{{ c.failedCount }}</td>
              <td>{{ c.createdAt | date:'medium' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-end" *ngIf="count > pageSize">
        <ngb-pagination [collectionSize]="count" [(page)]="page" [pageSize]="pageSize"
          (pageChange)="onPageChange($event)" [maxSize]="5" [rotate]="true" [boundaryLinks]="true">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>
